import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-chat-historico-uso-base-ia',
  templateUrl: './chat-historico-uso-base-ia.component.html',
  styleUrls: ['./chat-historico-uso-base-ia.component.scss']
})
export class ChatHistoricoUsoBaseIaComponent implements OnInit, OnDestroy {
  @Input() chat: any;
  lista: any[] = [];
  carregando: boolean = false;
  newSubs: Subscription | undefined;

  constructor(
    private chatService: ChatService,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    if (this.chat?._id) {
      this.carregando = true;
      this.newSubs = this.chatService.listarHistoricoUsoBaseIa(this.chat._id).subscribe({
        next: (result) => {
          this.lista = result?.lista || [];
          this.carregando = false;
        },
        error: (error) => {
          console.error('listarHistoricoUsoBaseIa', error);
          this.carregando = false;
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.newSubs?.unsubscribe();
  }

  close(): void {
    this.activeModal.close();
  }

  getBaseConhecimentoTitulo(baseConhecimento: any): string {
    return baseConhecimento?.nome || baseConhecimento?.nome_artigo || baseConhecimento?.artigo || baseConhecimento?.titulo || baseConhecimento?.id || '';
  }

  getChunks(baseConhecimento: any): string[] {
    return Array.isArray(baseConhecimento?.chunks) ? baseConhecimento.chunks : [];
  }

  formatarSemQuebraLinha(texto: any): string {
    return typeof texto === 'string' ? texto.replace(/\r\n|\r|\n/g, '\\n') : texto;
  }
}
